// Programs overview

import { useParams } from 'react-router-dom';
import DetailHero from "../components/Programs/ProgramsDetailHero";
import DetailOverview from "../components/Programs/ProgramDetailOverview";
import DetailTableAndList from '../components/Programs/ProgramDuration';        // for Program duration
import DetailGroupedCards from '../components/Programs/DetailedGroupedCard';    //For digital tracking
import DetailActions from "../components/Programs/ActionsButton";
import DetailImageCards from "../components/Programs/DetailedImageCards";
import data from "../programs.json";
import HeroSection from '../components/common/HeroSection';
import QuickSnapshot from '../components/Programs/QuickSnapshot';
import WhoThisIsForCards from '../components/Programs/WhoThisIsForCards';
import ProgramIncludedAndTrackerContainer from '../components/Programs/ProgramIncludedAndTrackerContainer';
import OutComesSection from '../components/Programs/OutComesSection';
import HowProgramdetailWorks from '../components/Programs/HowTheProgWorks';
import ProgramCTABanner from '../components/Programs/ProgramCTABanner';
import DigitalHealthFAB from '../components/Digitalhealth';

const { programDetails } = data;

/**
 * SectionRenderer — maps a section type string to its component.
 * Add new types here as you build more reusable components.
 */
const SectionRenderer = ({ section }) => {
  switch (section.type) {
    case 'tableAndList':
      return <DetailTableAndList data={section.data} />;
    case 'groupedCards':
      return <DetailGroupedCards data={section.data} />;
    case 'imageCards':
      return <DetailImageCards data={section.data} />;
    case 'actions':
      return <DetailActions data={section.data} />;
    default:
      console.warn(`ProgramDetailPage: unknown section type "${section.type}"`);
      return null;
  }
};

const ProgramDetailPage = () => {
  const { slug } = useParams();
  const program = programDetails?.[slug];
  const whoThisSection = {
    items: [
      {
        id: "01",
        description: "Trying to conceive for 6+ months without success",
        image: "/Programs/WhoIsThisForImages/ConceiveImage.jpg",
        label: "Popular",
      },
      {
        id: "02",
        description: "Have irregular or absent periods",
        image: "/Programs/OutComes/ConceptionImage.jpg"
      },
      {
        id: "03",
        description: "Diagnosed with PCOS / hormonal imbalance",
        image: "/Programs/WhoIsThisForImages/PCOSDiagnosisImage.jpg",
      },
      {
        id: "04",
        description: "Experienced previous failed conception attempts",
        image: "/Programs/WhoIsThisForImages/FailedAttemptsImage.jpg"
      }
    ]
  };
  const snapShotData1 = {
    snapShotData: [
      { label: "Duration", value: "3–6 months" },
      { label: "Format", value: "Hybrid (Medical + Lifestyle + Monitoring)" },
      { label: "Best for", value: "Trying to conceive / irregular cycles / hormonal imbalance" },
      { label: "Outcome Focus", value: "Ovulation health, egg quality, conception readiness" },
    ],
    image: "/Programs/OutComes/gynacImage.svg"
  }
  const heroSlide = [program.hero];
  return (
    <main className="w-full bg-white">
      {/* newly added sections */}
      <DigitalHealthFAB/>
      <HeroSection slides={heroSlide} />
      <QuickSnapshot snapShotData={program?.snapShotData?.snapShotData} image={program?.snapShotData?.image} />
      <WhoThisIsForCards section={program.whoThisSection} />
      <HowProgramdetailWorks data={program.Howprogramworkdetail} />
      <ProgramIncludedAndTrackerContainer />
      <OutComesSection />
      <ProgramCTABanner data={program.programCtaBanner} />


      {/* previous ones */}
      {/* <DetailHero data={program.hero} /> */}
      {/* <DetailOverview data={program.overview} />
      {program.sections?.map((section, index) => (
        <SectionRenderer key={`${section.type}-${index}`} section={section} />
      ))} */}

    </main>
  );
};

export default ProgramDetailPage;